<template>
  <base-dialog
    :action="onAction"
    :action-name="'Delete'"
    :close="onClose"
    :title="'Delete Card'"
  >
    <template #activator="{ on }">
      <slot
        name="activator"
        v-bind="{ on }"
      />
    </template>

    <template #content>
      <div>
        <p>
          The payment method will no longer be usable after removing from the customer.<br>
          <br>
          <b>Are you sure you want to delete this payment method? This can't be undone.</b>
        </p>
      </div>
    </template>
  </base-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import BaseDialog from "../Common/BaseDialog"

export default {
  components: { BaseDialog },
  props: {
    isPlatform: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    },
    customer: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      name: ''
    }
  },
  methods:{
    ...mapActions([ 'deleteCustomerPaymentMethod' ]),
    onClose(){
      this.$emit('close')
    },
    async onAction() {
      const payload = {
        id: this.id,
        customer: this.customer,
      }

      if (this.isPlatform) {
        payload._headers = { 'x-account': '' }
      }

      await this.deleteCustomerPaymentMethod(payload)

      this.$emit('action', payload)
    }
  }
}
</script>
